import React from 'react';
import PropTypes from 'prop-types';

const Card = ({
  type, image, color, newsTitle, title, date, theme,
  alumnus, url, featured, fieldType, intro, description,
  eventSubType, eventStartDate, eventEndDate, newsSubType,
  pastEvent,
}) => (
  <a
    className={`card ${featured && 'card--feature'} ${type === 'event' && 'card-inverse'}`}
    href={url}
    data-bkg={type !== 'event' ? '#FFF' : (pastEvent === true) ? '#7F7F7F' : '#000'}
    data-bkg-hover={color}
    data-past-event={pastEvent}
  >
    {newsSubType === 'Class Note' ? (
      <div className="card-note" style={{ backgroundColor: `${color}` }}>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: intro }} />
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    ) : (
      <div className="card-image">
        <figure className="image">
          <img src={image} alt="" />
        </figure>
      </div>
    )}

    <div className="card-content">
      {type === 'event' ? (
        <div className="card__label">
          {theme === '' ? eventSubType : theme}
          <span className="card__label-bar">|</span>
          {eventStartDate && eventStartDate !== eventEndDate ? `${eventStartDate} — ${eventEndDate}` : eventEndDate}
        </div>
      ) : (
        <div className="card__label">
          {theme === '' ? fieldType : theme}
          {fieldType === '' && type}
          <span className="card__label-bar">|</span>
          {date}
        </div>
      )}
      {type === 'event' ? (
        <div className="card__title">{title}</div>
      ) : (
        <div className="card__title">{newsTitle}</div>
      )}
      <ul className="card__alumni">
        {Object.entries(alumnus).map(([key, value]) => (
          <li key={key}>{value}</li>
        ))}
      </ul>
    </div>
  </a>
);

export default Card;

Card.defaultProps = {
  newsTitle: false,
  pastEvent: false,
};

Card.propTypes = {
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  newsTitle: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  intro: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
  featured: PropTypes.bool.isRequired,
  alumnus: PropTypes.objectOf(
    PropTypes.string,
  ).isRequired,
  newsSubType: PropTypes.string.isRequired,
  eventSubType: PropTypes.string.isRequired,
  eventStartDate: PropTypes.string.isRequired,
  eventEndDate: PropTypes.string.isRequired,
  pastEvent: PropTypes.bool,
};
